///Users/kacey/BoxyQR_Website/BoxyQR/boxyQR_website/client/src/components/ArticlesList.js
import React from 'react';
import { Link } from 'react-router-dom';
import { getAllArticles } from '../utils/articlesData';

const ArticlesList = () => {
  const articles = getAllArticles();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-gray-800 mb-8">Latest Articles</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles.map(article => (
          <div 
            key={article.id} 
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
          >
            <div className="p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">{article.title}</h2>
              <p className="text-sm text-gray-500 mb-4">
                <span>{article.date}</span>
                <span className="mx-1">•</span>
                <span>{article.author}</span>
              </p>
              <p className="text-gray-600 mb-4">{article.excerpt}</p>
              <Link 
                to={`/articles/${article.slug}`} 
                className="inline-block text-blue-600 hover:text-blue-800 font-medium"
              >
                Read more →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ArticlesList;